import { FETCH_PRODUCT_MAIN_INFO, ProductMainInfo, RESET } from 'features/product-info';
import {
  FETCH_RELATED_PRODUCTS,
  ViewsModels as RelatedProductsViewsModels,
} from 'features/related-products';
import { all, put, takeEvery } from 'redux-saga/effects';
import i18next from 'i18next';
import { ADD_NAVIGATION_SECTION, REMOVE_NAVIGATION_SECTION } from './page-navigation';

export function* navigationSaga() {
  yield all([
    put(
      ADD_NAVIGATION_SECTION({
        sectionId: 'reviews',
        navigationId: 'reviews',
        title: i18next.t('sticky-panel.navigation-tabs.reviews'),
      }),
    ),
    takeEvery([FETCH_PRODUCT_MAIN_INFO.failure, RESET], () =>
      put(REMOVE_NAVIGATION_SECTION({ sectionId: 'd9n' })),
    ),
    takeEvery([FETCH_PRODUCT_MAIN_INFO.failure, RESET], () =>
      put(REMOVE_NAVIGATION_SECTION({ sectionId: 'c14s' })),
    ),
    takeEvery(FETCH_PRODUCT_MAIN_INFO.success, resetD9nSectionOnInfoFectSuccess),

    // TODO: replace after realize fetch-data logic
    takeEvery(FETCH_RELATED_PRODUCTS.success, resetCollectionProductsOnInfoFetchSuccess),
    takeEvery(FETCH_RELATED_PRODUCTS.success, resetSubstitutesOnInfoFetchSuccess),
    takeEvery(FETCH_RELATED_PRODUCTS.success, resetComplementsOnInfoFetchSuccess),
  ]);
}

export function* resetD9nSectionOnInfoFectSuccess({ payload }: { payload: ProductMainInfo }) {
  const productInfo = payload.content[0];
  if (!!productInfo.marketingDescription) {
    yield put(
      ADD_NAVIGATION_SECTION({
        sectionId: 'd9n',
        navigationId: 'description',
        order: 1,
        title: i18next.t('sticky-panel.navigation-tabs.d9n'),
      }),
    );
  } else {
    yield put(REMOVE_NAVIGATION_SECTION({ sectionId: 'd9n' }));
  }

  if (productInfo.characteristics?.length) {
    yield put(
      ADD_NAVIGATION_SECTION({
        sectionId: 'c14s',
        navigationId: 'characteristics',
        order: 2,
        title: i18next.t('sticky-panel.navigation-tabs.c14s'),
      }),
    );
  } else {
    yield put(REMOVE_NAVIGATION_SECTION({ sectionId: 'c14s' }));
  }
}

export function* resetCollectionProductsOnInfoFetchSuccess({
  payload,
}: {
  payload: RelatedProductsViewsModels.RelatedProducts;
}) {
  const id = 'collectionProducts';
  if (payload?.collectionProducts?.length > 0) {
    yield put(
      ADD_NAVIGATION_SECTION({
        sectionId: id,
        navigationId: id,
        order: 3,
        title: i18next.t('sticky-panel.navigation-tabs.collection-products'),
      }),
    );
  } else {
    yield put(REMOVE_NAVIGATION_SECTION({ sectionId: id }));
  }
}

export function* resetSubstitutesOnInfoFetchSuccess({
  payload,
}: {
  payload: RelatedProductsViewsModels.RelatedProducts;
}) {
  if (payload?.substitutes?.length > 0) {
    yield put(
      ADD_NAVIGATION_SECTION({
        sectionId: 'substitutes',
        navigationId: 'substitutes',
        order: 5,
        title: i18next.t('sticky-panel.navigation-tabs.substitutes'),
      }),
    );
  } else {
    yield put(REMOVE_NAVIGATION_SECTION({ sectionId: 'substitutes' }));
  }
}

export function* resetComplementsOnInfoFetchSuccess({
  payload,
}: {
  payload: RelatedProductsViewsModels.RelatedProducts;
}) {
  if (payload?.complements?.length > 0) {
    yield put(
      ADD_NAVIGATION_SECTION({
        sectionId: 'complements',
        navigationId: 'complements',
        order: 4,
        title: i18next.t('sticky-panel.navigation-tabs.complements'),
      }),
    );
  } else {
    yield put(REMOVE_NAVIGATION_SECTION({ sectionId: 'complements' }));
  }
}
